import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { beforeEnterChatPageSafe } from '@/pages/view-chat'

import { resolveChatMessagingUiEnabled, whenAccessFeaturesReady } from '@/shared/composables/user-features/access-ui-resolvers'
import { pathNames } from '@/shared/utils/constants'

export async function chatBeforeEnter (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> {
  await whenAccessFeaturesReady()
  if (!resolveChatMessagingUiEnabled()) {
    next({ name: pathNames.MAIN })
    return
  }

  beforeEnterChatPageSafe(to)
  next()
}
